import React from 'react';
import classNames from 'classnames';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { HeartEmptyIcon, HeartFilledIcon } from '@reverbdotcom/cadence/icons/react';

export interface RCFavoriteButtonProps {
  favorited?: boolean;
  onClick?: (e?: any) => void;
  size?: 'default' | 'small' | 'large';
  shadowed?: boolean;
  disabled?: boolean;
  borderless?: boolean;
}

export function RCFavoriteButton({
  favorited = false,
  onClick,
  size = 'default',
  shadowed = false,
  disabled = false,
  borderless = false,
}: RCFavoriteButtonProps) {
  const classes = classNames(
    'rc-favorite-button',
    {
      'rc-favorite-button--favorited': favorited,
      'rc-favorite-button--shadowed': shadowed,
      'rc-favorite-button--borderless': borderless,
      'rc-favorite-button--large': size === 'large',
      'rc-favorite-button--small': size === 'small',
    },
  );

  return (
    <button
      className={classes}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      <RCIcon svgComponent={favorited ? HeartFilledIcon : HeartEmptyIcon} />
    </button>
  );
}
